<template>
    <div class="row justify-content-center">
        <div class="col-md-7 col-11">
            <card>
                <template slot="header">
                    Settings
                </template>
                <div class="form-group">
                    <label>Terms and Conditions</label>
                    <quill-editor v-model="settings.termsAndConditions"/>
                </div>
                <div class="d-flex justify-content-end">
                    <el-button
                        type="btn btn-primary"
                        @click="submit()"
                        :loading="saving">
                            Save
                    </el-button>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data () {
        return {
            saving: false
        }
    },
    computed: {
        ...mapState([
            'settings'
        ])
    },
    methods: {
        submit: async function () {
            try {
                this.saving = true
                await this.$store.dispatch('update', { path: 'settings', data: this.settings, id: '' })
            } catch (e) {
                console.log(e)
                console.log('error saving settings')
            }
            this.saving = false
        }
    }
}
</script>